/** Safe ID client (§25) — emergency profile, QR token, scans, finder messages. */
import { api } from './client';

const API_BASE = import.meta.env.VITE_API_BASE ?? 'https://api.kidzio.io';

export interface EmergencyProfile {
  child_id: string;
  enabled: boolean;
  first_name: string | null;
  photo_url: string | null;
  school_name: string | null;
  allergies: string | null;
  medical_notes: string | null;
  medication_notes: string | null;
  blood_type: string | null;
  languages: string | null;
  what_to_do: string | null;
  emergency_message: string | null;
  show_photo: boolean;
  show_allergies: boolean;
  show_medical: boolean;
  show_blood_type: boolean;
  show_school: boolean;
  allow_location_share: boolean;
  updated_at: string;
}

export interface SafeIdToken {
  child_id: string;
  token: string;
  active: boolean;
  created_at: string;
  url: string;
}

export interface ScanEvent {
  id: string;
  child_id: string;
  approx_lat: number | null;
  approx_lng: number | null;
  scanned_at: string;
}

export interface ContactMessage {
  id: string;
  child_id: string;
  body: string;
  finder_contact: string | null;
  approx_lat: number | null;
  approx_lng: number | null;
  read_at: string | null;
  created_at: string;
}

export const safeIdApi = {
  profile: (childId: string) =>
    api<EmergencyProfile>(`/v1/safe-id/children/${childId}/profile`),
  updateProfile: (childId: string, body: Partial<EmergencyProfile>) =>
    api<EmergencyProfile>(`/v1/safe-id/children/${childId}/profile`, { method: 'PUT', body }),
  token: (childId: string) => api<SafeIdToken>(`/v1/safe-id/children/${childId}/token`),
  rotate: (childId: string) =>
    api<SafeIdToken>(`/v1/safe-id/children/${childId}/token/rotate`, { method: 'POST' }),
  scans: (childId: string) => api<ScanEvent[]>(`/v1/safe-id/children/${childId}/scans`),
  familyScans: (hours = 24) =>
    api<ScanEvent[]>(`/v1/safe-id/family/scans?hours=${hours}`),
  messages: () => api<ContactMessage[]>('/v1/safe-id/messages'),
  markRead: (id: string) => api<ContactMessage>(`/v1/safe-id/messages/${id}/read`, { method: 'POST' }),
  qrUrl: (token: string) => `${API_BASE}/v1/safe-id/public/${token}/qr.svg`,
};
